export const DASHBOARD_COUNTS_URL = "dashboard/counts";
